import { MARKET_TYPES_MATCH, TIMEZONE_KEY_IN_LS } from '../constants';

const getGlobalState = (state, key) => (Array.isArray(state.common[key]) ? state.common[key].slice(0) : state.common[key]);

export const getSelectedMenu = (state) => getGlobalState(state, 'selectedMenu');
export const getSelectedSubMenu = (state) => getGlobalState(state, 'selectedSubMenu').toUpperCase();
export const getSelectedMenuItem = (state) => getGlobalState(state, 'selectedMenuItem');
export const getLoginError = (state) => getGlobalState(state, 'loginError');
export const getSvgVersion = (state) => getGlobalState(state, 'svgVersion');
export const getUser = (state) => getGlobalState(state, 'user');
export const getActiveModal = (state) => getGlobalState(state, 'activeModal');
export const getIsLoading = (state) => getGlobalState(state, 'isLoading');
export const getIsTennisLoading = (state) => getGlobalState(state, 'isTennisLoading');
export const getFilterData = (state) => getGlobalState(state, 'filterData');
export const isFetching = (state) => getGlobalState(state, 'isFetching');
export const toggleMenu = (state) => getGlobalState(state, 'toggleMenu');
export const toggleSubMenu = (state) => getGlobalState(state, 'toggleSubMenu');
export const getPagination = (state) => getGlobalState(state, 'pagination') || { page: 1, totalPage: 1 };
export const checkPermisson = (state, permission) => {
  const user = getUser(state);
  return user && user.permissions.indexOf(permission) !== -1;
};
export const hasError = (state) => getGlobalState(state, 'errorMessage');
export const getModalData = (state) => getGlobalState(state, 'modalData');
export const getProfileInfo = (state) => getGlobalState(state, 'profileInfo');
export const getCnt = (state) => getGlobalState(state, 'cnt');
export const getLeagues = (state) => getGlobalState(state, 'leagues');
export const getOddsHistoryTemplate = (state) => getGlobalState(state, 'oddsHistoryTemplate');
export const getAccounts = (state) => getGlobalState(state, 'accounts');

export const getMarkets = (state) => getGlobalState(state, 'markets');
export const getMarketsPrematchLive = (state) => getGlobalState(state, 'markets')?.filter((market) => market.type !== MARKET_TYPES_MATCH.LIVE);
export const getTennisMarkets = (state) => getGlobalState(state, 'tennisMarkets');
export const getMatchTimelineEvents = (state) => getGlobalState(state, 'matchTimelineEvents');
export const getPeriodId = (state) => getGlobalState(state, 'periods');
export const getEventType = (state) => getGlobalState(state, 'events');
export const getHeading = (state) => getGlobalState(state, 'heading');
export const requiresSaveBeforeNavigation = (state) => getGlobalState(state, 'requiresSaveBeforeNavigation');
export const getNextNavigationLink = (state) => getGlobalState(state, 'nextNavigationLink');
export const getTennisMatchTimelineEvents = (state) => getGlobalState(state, 'tennisMatchTimelineEvents');
export const getTennisOddsHistoryTemplate = (state) => getGlobalState(state, 'tennisOddsHistoryTemplate');
export const getTennisCompetitions = (state) => getGlobalState(state, 'tennisCompetitions');
export const getTennisEventStatus = (state) => getGlobalState(state, 'tennisEventStatus');
export const getIsTennisEnabled = (state) => getGlobalState(state, 'isTennisEnabled');

export const getTimezone = (state) => getGlobalState(state, TIMEZONE_KEY_IN_LS);
